export async function ConspostratamientoUpdate(
  conspostResp,
  metaFecha,
  conspostMedio,
  conspostTipo,
  conspostObs,
  tratamientoId,
  pacienteId,
  conspostratId
) {
  const formData = {
    // taxID-mind-mindNumses
    title: `us-${pacienteId}-tr-${tratamientoId}-conspost-${metaFecha}`,
    slug: `us-${pacienteId}-tr-${tratamientoId}-conspost-${metaFecha}`,
    status: "publish",
    tratamiento: tratamientoId,
    paciente: pacienteId,
    meta: {
      conspostResp: conspostResp,
      metaFecha: metaFecha,
      conspostMedio: conspostMedio,
      conspostTipo: conspostTipo,
      conspostObs: conspostObs,
    },
  };

  const authToken = sessionStorage.getItem("token");

  try {
    const response = await fetch(
      `https://app.tavad.com/hce/wp-json/wp/v2/conspostrat/${conspostratId}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(formData),
      }
    );
    const values = await response.json();
    console.log(values);
    return values;
  } catch (error) {
    console.error(error);
  }
}
